
import * as turf from '@turf/turf'

export interface LocationT {
    latitude: number
    longitude: number
}

/**
 * 
 * @param from  LocationT
 * @param to LocationT
 */
export const getDistance = (from: LocationT, to: LocationT): number => {
    var fromPoint = turf.point([from.longitude, from.latitude]);
    var toPoint = turf.point([to.longitude, to.latitude]);
    var options = { units: 'miles' };
   

    // @ts-ignore
    var distance = turf.distance(fromPoint, toPoint, options);
    return distance


}
